export default {
    ExternalPlatformProducts: {
        Channel: 'Channel',
        Store: 'Store',
        ProductID: 'Platform Product ID',
        specificationID: 'Platform specification ID',
        ProductCode: 'Platform Product Code',
        specificationCode: 'Platform specification code',
        status: 'Matching status',
        Method: 'Matching Method',
        productstatus: 'Platform product status',
        inventory: 'Synchronize inventory',
        Capture: 'Write-back Capture Tag',
        CaptureTip: 'When enabled, the tag csg-captured will be added to the source order on Shopify after the order is captured into CSG Hub.',
        Activity: 'Activity status',
        type: 'System product type',
        creation: 'Platform creation time',
        acquisition: 'System acquisition time',
        download: 'Product download',
        byID: 'Download by product ID',
        bytime: 'Download by time period',
        Manual: 'Manual matching',
        System: 'System matching',
        Excel: 'Excel Import Matching',
        More: 'More',
        Listing: 'Listing',
        Off: 'Off shelf',
        Synchronize: 'Synchronize inventory',
        Inventorylog: 'Inventory synchronization log',
        the: 'Platform Product ID (the system product ID of the platform, which is not manually filled in with a code, one per line, entered in a new line or separated by a comma in English, with a maximum of 100 entries allowed)',
        form: {
            Channel: 'Channel',
            Store: 'Store',
            image: 'Platform product image',
            Name: 'Platform Product Name',
            Code: 'Platform Product Code',
            Platformname: 'Platform specification name',
            Platformcode: 'Platform specification code',
            PlatformID: 'Platform Product ID',
            specificationID: 'Platform specification ID',
            status: 'Activity status',
            Price: 'Price',
            productstatus: 'Platform product status',
            Matching: 'Matching status',
            method: 'Matching method',
            System: 'System product type',
            product: 'System product name',
            ProductCode: 'System Product Code',
            Systemname: 'System SKU name',
            SKU: 'System SKU code',
            Inventory: 'Platform Inventory',
            occupied: 'Inventory occupied',
            Occupation: 'Occupation method',
            creation: 'Platform creation time',
            acquisition: 'System acquisition time',
        },
        Matching: 'Matching products',
        Product: 'Product classification',
        Productbrand: 'Product brand',
        Productcode: 'Product code',
        Productname: 'Product name',
        SKUcode: 'SKU',
        SKUname: 'SKU name',
        Sales: 'Sales price',
        Please: 'Please enter the product code',
        enter: 'Please enter SKU code',
        downloading: 'Manually downloading products',
        operation: 'This operation involves changes to the SKU level. Do you want to continue?',
        Items: 'Items that failed to match cannot be synchronized',
        Log: 'Log',
        confirm: {
            store: 'Select a store',
            Encoding: 'Encoding',
            Name: 'Name',
            Sales: 'Sales Channel',
            Type: 'Type',
            status: 'Authorization status',
            enter: 'Please enter the online store code',
            Please: 'Please enter the online store name',
            select: 'Please select a channel',
        }
    }
};
